module.exports = __webpack_public_path__ + "img/personal_icon_data@2x.ba1747e4.png";